import { lazy } from "react";
import locales from "./locales";
import routes from "./routes";
import themes from "./themes";
import parseLanguages from "utility/locale";
import Loading from "UIComponents/Loading/Loading";
import { getDefaultRoutes } from "./getDefaultRoutes";
import { RECORD_SEP, UNIT_SEP } from "papaparse";

const config = {
  googleMaps: {
    apiKey: "AIzaSyByMSTTLt1Mf_4K1J9necAbw2NPDu2WD7g",
  },
  auth: {
    redirectTo: "/Dashboard",
    persistKey: "base-shell:auth",
    signInURL: "/",
  },
  getDefaultRoutes: getDefaultRoutes,
  routes,
  locale: {
    locales,
    persistKey: "base-shell:locale",
    defaultLocale: parseLanguages(["en", "de", "ru"], "en"),
    onError: (e) => {
      //console.warn(e)

      return;
    },
  },
  menu: {},
  theme: {
    themes,
    defaultThemeID: "default",
    defaultType: "light",
  },
  pages: {
    //LandingPage: lazy(() => import('../pages/LandingPage')),
    PageNotFound: lazy(() => import("../pages/PageNotFound")),
  },
  components: {
    Menu: lazy(() => import("../containers/Menu/Menu")),
    Loading,
  },
  containers: {
    LayoutContainer: lazy(
      () => import("../containers/MainContainer/MainContainer"),
    ),
    //AppContainer: null -- Hook if needed at the app layer.
  },
  controlPanel: {
    marketConfig: {
      seekerMarkets: ["walmart", "google", "amazon", "ebay"],
      defaultSeekerSettings: {
        keywords: [
          {
            keyword: "",
            config: {
              sigil_max_page: 5,
              facet_walmart: "brand:brand+name",
              include_filters_walmart: "true",
              refinements_amazon: "n:12341234",
            },
          },
        ],
        collectorConfig: {
          excludeSellers: ["amazon.com", "walmart", "ebay"],
          isMarketResult: true,
          isRetailResult: true,
        },
        matchMakerConfig: {
          fuzzyThreshold: 210,
          listingTitleExclusions: [],
        },
      },
    },
  },
  csvConfigs: {
    papaParseConfig: {
      delimiter: "", // auto-detect
      newline: "", // auto-detect
      quoteChar: '"',
      escapeChar: '"',
      header: true,
      transformHeader: undefined,
      dynamicTyping: false,
      preview: 0,
      encoding: "",
      worker: false,
      comments: false,
      step: undefined,
      complete: undefined,
      error: undefined,
      download: false,
      downloadRequestHeaders: undefined,
      downloadRequestBody: undefined,
      skipEmptyLines: true,
      chunk: undefined,
      chunkSize: undefined,
      fastMode: undefined,
      beforeFirstChunk: undefined,
      withCredentials: undefined,
      transform: undefined,
      delimitersToGuess: [",", "\t", "|", ";", RECORD_SEP, UNIT_SEP],
    },
    cleanList: {
      validCsvProps: [
        "name",
        "fullAddress",
        "address1",
        "address2",
        "city",
        "state",
        "zip",
        "country",
        "email",
        "phone",
        "walmartId",
        "amazonId",
        "ebayId",
        "googleId",
        "alibabaId",
      ],
      requiredProps: ["name"],
    },
    newProducts: {
      validCsvProps: [
        "name",
        "map",
        "googleId",
        "walmartId",
        "amazonId",
        "ebayId",
        "upc",
        "model",
        "sku",
        "trademark",
      ],
      requiredProps: ["name", "map", "trademark"],
    },
  },
  messaging: {
    authorizedSellers: {
      default: "Dear {{Seller Name}},",
    },
    contactSellersMessages: {
      default:
        "Dear {{Seller Marketplace Name}},\r\n\r\nI am looking at buying THING, but I'd like to know if there's a warranty policy. {{Listing Url}}. Can you please send me a copy of the warranty on this product?\r\n\r\nThanks!",
    },
    followupMessages: {
      default:
        "Just following up on this, do you have an update for me? Thanks!",
    },
    reportSellerScript: {
      amazon: {
        script:
          'function getElem(id){const elem=document.getElementById(id);return elem||console.error("Element not found: ",id),elem}function getElemBySelector(selector){const elem=document.querySelector(selector);return elem||console.error("Element not found: ",selector),elem}function runAction(actions,delay){if(0===actions.length)return;const[currentAction,...remainingActions]=actions;setTimeout((()=>{currentAction(),runAction(remainingActions,delay)}),delay)}const actions=[],additionalDetails=!!getElem("inputFirstName");actions.push((()=>{getElem("inputAgent").scrollIntoView({behavior:"instant"}),getElem("inputAgent").click(),getElem("inputPrimaryComplaint").scrollIntoView({behavior:"instant"}),getElem("inputPrimaryComplaint").click()})),actions.push((()=>{getElem("inputPrimaryComplaint_3").click()})),actions.push((()=>{getElem("inputAdditionalInformation").scrollIntoView({behavior:"instant"}),getElem("inputAdditionalInformation").value="{0}",getElem("inputBrandName").value="{{My Company Name}}",getElem("inputWhatIntellectProp").value="Trademark"}));const asins=[{1}],sellerName="{{Seller Marketplace Name}}";asins.forEach((asin=>{actions.push((()=>{getElem("inputASIN").value=asin,getElem("inputGoButton").click()})),actions.push((()=>{const elem=getElem(`inputInfringingElement-${asin}`);elem.selectedIndex=1,elem.dispatchEvent(new Event("change"))})),actions.push((()=>{getElemBySelector(`label[for^="seller${asin}"] input[name="${sellerName}"]`).click()}))})),additionalDetails?(actions.push((()=>{getElem("inputNotSeller").checked=!0,getElem("inputFirstName").value="Alice",getElem("inputLastName").value="Brown",getElem("inputCompany").value="Sigil",getElem("inputAddress1").value="445 Broadway",getElem("inputAddress2").value="",getElem("inputCity").value="Denver",getElem("inputState").value="CO",getElem("inputZipCode").value="80203",getElem("inputPhoneNumber").value="720-515-5706",getElem("inputContactThirdPartySellersName").value="Alice Brown",getElem("inputContactThirdPartySellersEmail").value="amazon.violations@sigilpricing.com",getElem("inputCountry").scrollIntoView({behavior:"instant"})})),actions.push((()=>{getElem("inputCountry").click()})),actions.push((()=>{getElem("inputCountry_215").click()}))):console.warn("Your contact details section not found. Skipping automation."),actions.push((()=>console.log("Sigil Amazon autofill completed. Please verify the form is correct."))),runAction(actions,800);',
        additionalInfo:
          "Seller is listing products under detail pages that do not exactly match the items they are selling, because the products are materially different. We contacted the seller and confirmed the products are different, but they are still wrongly offering them. This hurts the rights owner's brand and infringes its US trademark {{NUMBER}}. It is also fraud. We cannot report this material difference through Amazon's normal reporting location (Contact Us within Seller Central) because this rights owner does not sell on Amazon and does not have access to Seller Central. Regardless, the violation is correctly reported here because this seller is infringing the rights owner's trademark. The listing must be corrected to list the product as used, or removed.",
      },
    },
  },
};

export default config;
